import { combineSlices } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import localStorage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";

import { nextCargoApi } from "./apis/baseApi";
import { ipifyApi } from "./apis/ipify";
import { authSlice, notificationSlice, toleranceSlice } from "./slices";
import { settingsSlice } from "./slices/settings";

const persistConfig = {
  key: "@root",
  storage: localStorage,
  version: 1,
  blacklist: [nextCargoApi.reducerPath, ipifyApi.reducerPath, authSlice.name, toleranceSlice.name, settingsSlice.name, notificationSlice.name]
};

const authPersistConfig = {
  key: `@${authSlice.name}`,
  version: 1,
  storage: sessionStorage
};

const settingsPersistConfig = {
  key: `@${settingsSlice.name}`,
  version: 1,
  storage: sessionStorage
};

export const rootReducer = combineSlices(nextCargoApi, ipifyApi, toleranceSlice, notificationSlice, {
  [authSlice.name]: persistReducer(authPersistConfig, authSlice.reducer),
  [settingsSlice.name]: persistReducer(settingsPersistConfig, settingsSlice.reducer)
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);
